<template>
  <div style="width: 100%">
  <h1>Received History</h1>
    <operator-table
        :orders="orders"
        :pagination="pagination"
        :headers="headers"
        @getData="getWalkingReport"
    >
    </operator-table>
  </div>
</template>

<script>
import {eventBus} from '@/main';
import OperatorOrdersService from "@/services/Operator/OperatorOrders";
import OperatorTable from "@/components/Operator/OperatorTable";

export default {
  name: 'OperatorReport',
  components: {OperatorTable},
  data() {
    return {
      orders: [],
      pagination: {
        visible: 5
      },
      headers: [
        {text: 'Order #', value: 'id', sortable: false},
        {text: 'User', value: 'name'},
        {text: 'Phone', value: 'phone'},
        {text: 'Created', value: 'created'},
        {text: 'Total amount', value: 'total_amount'},
        {text: 'Date received', value: 'date_received'}
      ],
    }
  },
  created() {
    eventBus.$on('do-operator-search', this.getWalkingReport);
  },
  beforeDestroy() {
    eventBus.$off('do-operator-search', this.getWalkingReport);
  },
  mounted() {
    this.getWalkingReport()
  },
  methods: {
    getWalkingReport(searchData) {
      let url = ''
      for (let param in this.$router.currentRoute.query) {
        url += '&' + param + "=" + this.$router.currentRoute.query[param]
      }
      if ((typeof searchData === 'string' || searchData instanceof String) && searchData.trim().length > 0) {
        url += '&search=' + searchData.trim();
      }
      this.$store.commit('setLoading', true);
      OperatorOrdersService.getHistory(this.pagination.page, url)
          .then(response => {
            if (response.status === this.$response.Ok) {
              this.orders = response.data.data
              this.pagination.page = response.data.meta.current_page
              this.pagination.total = response.data.meta.total
              this.pagination.perPage = response.data.meta.per_page
              this.pagination.lastPage = response.data.meta.last_page
              this.$router.push('/operator/history/' + this.pagination.page)
            }
          })
          .catch(error => {
            this.$store.commit('setError', error.response);
          })
          .finally(() => {
            this.$store.commit('setLoading', false);
          })
    },
  },
  computed: {
    loading() {
      return this.$store.getters.loading;
    }
  }
}
</script>
